<nb-card>
  <nb-card-header>Confirm</nb-card-header>
  <nb-card-body>
    <p>
      This operation supposed to be approved!<br />
      Do you want to proceed?
    </p>
  </nb-card-body>
  <nb-card-footer class="leshack-delete-dialog-footer">
    <button nbButton status="info" (click)="onCancel()">Cancel</button>
    <button nbButton status="success" (click)="onApprove()">Approve</button>
  </nb-card-footer>
</nb-card>
